import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'common/frontend/firebase/init';
import 'common/services/errorHandler';
import 'services/sentry/frontendSdkInit';

import 'services/initDataGridPro';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import ReduxRoot from './ReduxRoot';
import AppRouter from './AppRouter';
import { PortalsProvider } from 'components/Portals/portalsContext';

import { unregister } from 'services/registerServiceWorker';

import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import * as Themes from 'common/styles/themes';
import { IconContext } from 'react-icons';
import iconConfig from 'common/styles/icons';
import NotificationManager from './NotificationManager';
import UserManager from './UserManager';

unregister();
ReactDOM.render(
	<ReduxRoot>
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={Themes.RentleLight}>
				<CssBaseline />
				<PortalsProvider>
					<IconContext.Provider value={iconConfig}>
						<AppRouter />
						<NotificationManager />
						<UserManager />
					</IconContext.Provider>
				</PortalsProvider>
			</ThemeProvider>
		</StyledEngineProvider>
	</ReduxRoot>,
	document.getElementById('root') as HTMLElement,
);
